import {Trans} from 'react-i18next'
export const items =[
    { name: <Trans i18nKey="Menulist.Aboutme">About Me</Trans>, link: "start" },
    { name: <Trans i18nKey="Menulist.Location">Location</Trans>, link: "location" },
    { name: <Trans i18nKey="Menulist.related">Related</Trans>, link: "related-symptoms" },
    //{ name: 'Symptoms ', link: "NLPsymptom" },
    { name: <Trans i18nKey="Menulist.interview">Interview</Trans>, link: "questions" },
    { name: <Trans i18nKey="Menulist.selectcare">Select Care</Trans>, link: "care-options" },
]
export const emergencyItems=[
    { name: <Trans i18nKey="Menulist.Location">Location</Trans>, link: "location" },
    { name: <Trans i18nKey="Menulist.selectcare">Select Care</Trans>, link: "emergency" },
]

export const travelAidItems=[
    { name: <Trans i18nKey="Menulist.Location">Location</Trans>, link: "location" },
    { name: <Trans i18nKey="Menulist.Aboutme">About Me</Trans>, link: "start" },
    { name: <Trans i18nKey="Menulist.related">Related</Trans>, link: "related-symptoms" },
    { name: <Trans i18nKey="Menulist.selectcare">Select Care</Trans>, link: "care-options" },
]

